import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    primaryButton: {
      color: Colors.WHITE,
      backgroundColor: Colors.GREEN_DARK,
      "&.MuiButton-root": {
        marginTop: 0,
        backgroundColor: Colors.GREEN_DARK,
      },
      "&.MuiButton-root:hover": {
        backgroundColor: Colors.GREEN_DARK,
      },
      "&:active": {
        backgroundColor: Colors.GREEN_DARK,
      },
      "&.MuiButton-root.Mui-disabled": {
        backgroundColor: "#8abb8f",
        color: Colors.WHITE,
      },
    },
  })
);

export default useStyles;
